module.exports = __webpack_public_path__ + "static/getstarted1-616bd2a8aea2dbc66cdbd556fe57ca27.jpg";